import React from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{ backgroundColor: "#ffeae9", padding: "2rem" }}
    >
      <div className="mb-4">
        <button
          className="btn btn-light border rounded-circle"
          style={{ width: "42px", height: "42px" }}
          onClick={() => navigate("/")}
        >
          <img
            src="/arrow_back.png"
            alt="Go Back"
            style={{ width: "22px", height: "22px" }}
          />
        </button>
      </div>

      {/* Main Content */}
      <div className="container bg-white rounded-4 shadow p-4" style={{ zIndex: 1 }}>
        <h1 className="mb-4 text-center">Privacy Policy</h1>

        <p>
          Your privacy is important to us at <strong>EduLink</strong>. This policy outlines how we collect,
          use, and protect your personal information when you use our services.
        </p>

        <h4 className="mt-4">1. Information We Collect</h4>
        <ul className="ms-4">
          <li>Name</li>
          <li>Email address</li>
          <li>User role (Student/Teacher)</li>
          <li>Course preferences</li>
        </ul>

        <h4 className="mt-4">2. How We Use Your Data</h4>
        <ul className="ms-4">
          <li>Personalize your experience</li>
          <li>Improve platform performance</li>
          <li>Send notifications and updates</li>
        </ul>

        <h4 className="mt-4">3. Your Rights</h4>
        <p>
          You have the right to access, update, or delete your personal information at any time.
          Contact us at <a href="mailto:help@edulink.com">help@edulink.com</a> for more details.
        </p>

        <h4 className="mt-4">4. Contact Us</h4>
        <p>
          If you have any questions about this policy, reach out at <strong>help@edulink.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
